import React, { useState } from "react";
import Swal from "sweetalert2";
import { create } from "../../../constants/apiRoutes";

const ManualRate = () => {
  const [formData, setFormData] = useState({
    usdounz: "",
    rate24Karat: "",
    rate22Karat: "",
    rate21Karat: "",
    rate18Karat: "",
    rate14Karat: "",

  });
  const handleSubmit = async () => {
    const postDataDisplay = `
    <p><strong>Gold Ounz USD:</strong> ${formData.usdounz}</p>
    <p><strong>14 Karat Rate:</strong> ${formData.rate14Karat}</p>
    <p><strong>18 Karat Rate:</strong> ${formData.rate18Karat}</p>
    <p><strong>21 Karat Rate:</strong> ${formData.rate21Karat}</p>
    <p><strong>22 Karat Rate:</strong> ${formData.rate22Karat}</p>
    <p><strong>24 Karat Rate:</strong> ${formData.rate24Karat}</p>
    
  `;
    const { value: confirmed } = await Swal.fire({
      title: "Are you sure?",
      html: `
      <p>You won't be able to revert this!</p>
      ${postDataDisplay}
    `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Save it!",
      cancelButtonText: "Don't Save",
    });

    if (confirmed) {
      try {
        let postData = {
          rate14Karat: formData.rate14Karat,
          rate18Karat: formData.rate18Karat,
          rate21Karat: formData.rate21Karat,
          rate22Karat: formData.rate22Karat,
          rate24Karat: formData.rate24Karat,
          usdounz: formData.usdounz,
          timestamp: new Date(),
        };
         await create(`Rates/insert`, postData);
        handleClear();
        Swal.fire({
          icon: "success",
          title: "Rates Added and broadcasted successfully.",
          showConfirmButton: false,
          timer: 2000,
        });
      } catch (error) {
        console.error("Error saving data", error);
      }
    } 
  };

  const handleClear = () => {
    setFormData({
      usdounz: "",
      rate24Karat: "",
      rate22Karat: "",
      rate21Karat: "",
      rate18Karat: "",
      Rate14Karat: "",
    });
  };

  return (
    <div>
      <section className=" my-10 mx-20">
        <h2 className="text-2xl font-bold mb-4">Manual Rate Broadcast</h2>
        <div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            className="p-2 rounded-xl border-2 border-gray-200 bg-white"
          >
            <div className="w-full overflow-x-auto">
              <div className="flex flex-row gap-4 min-w-max px-4 py-2 ">
                {[
                  {
                    label: "Gold Ounz Rate USD :",
                    name: "usdounz",
                    placeholder: "Gold Ounz USD",
                  },
                  {
                    label: "24 Karat :",
                    name: "rate24Karat",
                    placeholder: "24 Karat",
                  },
                  {
                    label: "22 Karat :",
                    name: "rate22Karat",
                    placeholder: "22 Karat",
                  },
                  {
                    label: "21 Karat :",
                    name: "rate21Karat",
                    placeholder: "21 Karat",
                  },
                  {
                    label: "18 Karat :",
                    name: "rate18Karat",
                    placeholder: "18 Karat",
                  },
                  {
                    label: "14 Karat :",
                    name: "rate14Karat",
                    placeholder: "14 Karat",
                  },
                ].map((item, idx) => (
                  <label
                    key={idx}
                    className="flex flex-col justify-between  border-2 bg-gray-200 rounded-xl shadow-sm p-4 w-[170px] flex-shrink-0"
                  >
                    <p className="text-xs font-semibold text-gray-700 mb-2">
                      {item.label}
                    </p>
                    <input
                      type="number"
                      step=".01"
                      min={0}
                      name={item.name}
                      required
                      value={formData[item.name] || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData({
                          ...formData,
                          [item.name]: value,
                        });
                      }}
                      onBlur={(e) => {
                        const value = parseFloat(e.target.value);
                        setFormData({
                          ...formData,
                          [item.name]: isNaN(value) ? "" : value.toFixed(2),
                        });
                      }}
                      className="focus:outline-none text-gray-600 font-semibold text-xs rounded-lg p-2 border border-gray-200 text-end"
                      placeholder={item.placeholder}
                    />
                  </label>
                ))}
              </div>
            </div>

            <div className="flex w-full gap-2 justify-end mt-4">
              <button
                type="submit"
                className="text-xs font-semibold bg-yellow-700 text-white w-24 h-9 rounded-lg mr-5"
              >
                Save
              </button>
              <button
                type="reset"
                onClick={() => handleClear()}
                className="text-xs bg-black font-semibold text-white w-24 h-9 rounded-lg mr-5 "
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </section>
      {/* <p className="text-center m-4 text-2xl text-gray-400">Loading....</p> */}
    </div>
  );
};

export default ManualRate;
